import { FC, ReactNode, useEffect, useState } from "react";
import { DEMO_STAY_LISTINGS } from "data/listings";
import { StayDataType } from "data/types";
// import ButtonPrimary from "shared/Button/ButtonPrimary";
import HeaderFilter from "./HeaderFilter";
import StayCard from "components/StayCard/StayCard";
import { getFeaturedProducts } from "data/api";

// OTHER DEMO WILL PASS PROPS
const DEMO_DATA: StayDataType[] = DEMO_STAY_LISTINGS.filter((_, i) => i < 8);

//
export interface SectionGridFeaturePlacesProps {
  stayListings?: StayDataType[];
  gridClass?: string;
  heading?: ReactNode;
  subHeading?: ReactNode;
  headingIsCenter?: boolean;
  tabs?: string[];
}

const SectionGridFeaturePlaces: FC<SectionGridFeaturePlacesProps> = ({
  stayListings = DEMO_DATA,
  gridClass = "",
  heading = "Featured Products",
  subHeading = "Popular products that we recommend",
  headingIsCenter,
  tabs = [],
}) => {
  const renderCard = (stay: any) => {
    return <StayCard key={stay.SKU} data={stay} />;
  };
  const [data, setData] = useState([]);
  useEffect(() => {
    getFeaturedProducts().then((item) => {
      if (item?.data) {
        const filteredAndSliced = item.data
          .filter((record: { image_urls: Array<String>; }) => record.image_urls.length !== 0) // Filter records that have a truthy 'imageLink' value
          .slice(-8);
        setData(filteredAndSliced);
      }
    });
  }, []);

  return (
    <div className="nc-SectionGridFeaturePlaces relative">
      <HeaderFilter
        tabActive={"New York"}
        subHeading={subHeading}
        tabs={tabs}
        heading={heading}
        onClickTab={() => { }}
      />
      <div
        className={`grid gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 ${gridClass}`}
      >
        {/* {DEMO_DATA.map((stay) => renderCard(stay))} */}
        {data?.map((stay) => renderCard(stay))}
      </div>
      {/* <div className="flex mt-16 justify-center items-center">
        <ButtonPrimary loading>Show me more</ButtonPrimary>
      </div> */}
    </div>
  );
};

export default SectionGridFeaturePlaces;
